import React from "react";
import Home from "../../components/Home";
import Car from "../../components/Carousel";
import Footer from "../../components/Footer";
import GridExample from "../../components/Card";



export default function Homepage() {
  return (
    <div>
      <Home></Home>
      <Car></Car>
      <br/>
      <br/>
      <br/>
      <br/>
   <GridExample></GridExample>
   <br/>
   <br/>
      <Footer></Footer>
    </div>
    
  );
}


// import React from "react";
// import AppreciationPage from "../../components/TThak";



// function App() {
//   return (
//     <div className="App">
// <AppreciationPage></AppreciationPage>
//   </div>
//   );
// }

// export default App;
